import * as React from 'react'

import { IEnhancedLocation } from '../../../../common/reducers/reactRouterLocation'
import { IDecoratedItem } from '../../../../typings/searchResults'
import ItemCard from '../../itemCard'
import ItemCardsLayout from '../../itemCardsLayout'
import { IItemsListing } from '../index'

interface IProps extends IDecoratedItem {
  location: IEnhancedLocation
}

const Default = ({ items, itemDecorator, viewType }: IItemsListing) => (
  <ItemCardsLayout viewType={viewType}>
    {items.map((item, index) => {
      const itemProps = itemDecorator(item, index) as IProps
      return (
        <ItemCardsLayout.CardArea key={item.id}>
          <ItemCard {...itemProps} index={index} viewType={viewType} />
        </ItemCardsLayout.CardArea>
      )
    })}
  </ItemCardsLayout>
)
export default Default
